module.exports = __webpack_public_path__ + "img/13-sdg-full@2x.4fba80c2.png";